<template>
  <div :class="['background', backgroundClass]">
    <TransitOverlay :active="movementActivated" :position-id="positionId"/>
  </div>
</template>

<script>
import TransitOverlay from "@/components/Game/Location/TransitOverlay.vue";

export default {
  name: "BackgroundView",
  components: {TransitOverlay},
  props: {
    background: {
      type: String,
      required: false,
      default: '',
    },
    movementActivated: {
      type: Boolean,
      default: false,
    },
    positionId: {
      type: String,
      default: '',
    },
  },
  computed: {
    backgroundClass() {
      // If background is empty, return a default class
      if (!this.background) {
        return 'background-default';
      }
      // Generate a unique class name based on the background URL
      const className = `background-${btoa(this.background).replace(/=/g, "")}`;
      this.updateDynamicStyle(className, this.background);
      return className;
    },
  },
  methods: {
    updateDynamicStyle(className, imageUrl) {
      // Skip creating style for default or empty backgrounds
      if (className === 'background-default' || !imageUrl) {
        return;
      }

      const existingStyle = document.getElementById(className);
      if (!existingStyle) {
        const style = document.createElement("style");
        style.id = className;
        style.textContent = `
          .${className} {
            background-image: url('${imageUrl}');
          }
        `;
        document.head.appendChild(style);
      }
    },
  },
};
</script>

<style scoped>
.background {
  position: relative;
  width: 100%;
  height: 80vh;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  /* Smooth transition effect for background */
  transition: background-image 1s ease-in-out, opacity 1s ease-in-out;
}

/* Default background when no image is provided */
.background-default {
  background-color: #1a1a1a; /* Dark background color */
}

</style>
